/**
 * Session store — idle tracking + the "session expired" flag.
 *
 * `expired` flips to true when a refresh fails (API client) or after 15 min of
 * total inactivity; the AppLayout shows SessionExpiredModal in response.
 */
import { create } from 'zustand'

export const IDLE_TIMEOUT_MS = 15 * 60 * 1000

interface SessionState {
  lastActivity: number
  expired: boolean
  markActivity: () => void
  isIdle: () => boolean
  expire: () => void
  reset: () => void
}

export const useSessionStore = create<SessionState>((set, get) => ({
  lastActivity: Date.now(),
  expired: false,
  markActivity: () => set({ lastActivity: Date.now() }),
  isIdle: () => Date.now() - get().lastActivity > IDLE_TIMEOUT_MS,
  expire: () => set({ expired: true }),
  reset: () => set({ expired: false, lastActivity: Date.now() }),
}))
